import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import basics from './basics/index';
import category from './category/index';
import brand from './brand/index';
import contact from './contact/index';
export default {
  meta: {
    title: '店铺信息',
    auth: true,
    authorityValue: 'store-store-management'
  },
  name: 'storeInfo',
  components: {
    basics: basics,
    category: category,
    brand: brand,
    contact: contact
  },
  data: function data() {
    return {
      activeName: 'basics',
      tabList: [],
      uploadToken: '',
      load: false
    };
  },
  methods: {
    handleClick: function handleClick() {
      var _this = this;

      var item = this.tabList.find(function (v) {
        return v.name == _this.activeName;
      });

      if (JSON.stringify(item.form) != '{}') {
        return;
      } else {
        var key = "dataBind".concat(this.activeName.slice(0, 1).toUpperCase()).concat(this.activeName.slice(1));
        this[key]();
      }
    },
    dataBindBrand: function dataBindBrand(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$api.brands(item);

              case 2:
                data = _context.sent;
                _this2.tabList[2].form = data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataBindBasics: function dataBindBasics(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$api.information(item);

              case 2:
                data = _context2.sent;
                _this3.tabList[0] && _this3.$set(_this3.tabList[0], 'form', data);
                _this3.tabList[1] && _this3.$set(_this3.tabList[1], 'form', data);
                _this3.tabList[3] && _this3.$set(_this3.tabList[3], 'form', data);
                _this3.load = true;

                _this3.$forceUpdate();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    init: function init() {
      var _this4 = this;

      var list = [{
        label: '店铺基础信息',
        name: 'basics',
        form: {}
      }, {
        label: '经营类目',
        name: 'category',
        form: {}
      }, {
        label: '店铺品牌',
        name: 'brand',
        form: {}
      }, {
        label: '店铺联系方式',
        name: 'contact',
        form: {}
      }];
      var tab = ['store-store-information', 'store-store-category', 'store-store-brand', 'store-store-contact'];
      tab.forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(v, i) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  ;
                  _context3.next = 3;
                  return _this4.isShowAuto(v);

                case 3:
                  _context3.t0 = _context3.sent;

                  if (!_context3.t0) {
                    _context3.next = 6;
                    break;
                  }

                  _this4.tabList.push(list[i]);

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  created: function created() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _yield$_this5$$api$ge, token;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.init();

            case 2:
              _this5.dataBindBasics();

              _context4.next = 5;
              return _this5.$api.getUploadToken();

            case 5:
              _yield$_this5$$api$ge = _context4.sent;
              token = _yield$_this5$$api$ge.token;
              _this5.uploadToken = token;

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};